export default __webpack_public_path__ + "static/on_a_journey-c399d1307148fb6cdac03f25bb2a788d.png";